import {Injector} from '@angular/core';

export class ServiceInjector {
  static instance: Injector = null;
}
